import $ from 'jquery';
import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown';
import LikeData from 'component_data/like';
import LikeButton from 'component_ui/like';
import AddComment from 'component_ui/add-comment';
import FullScreen from 'component_ui/full-screen';
import FullscreenModeUI from 'component_ui/fullscreen-mode';
import ToggleVisible from 'component_ui/toggle-visible';
import ImageUI from 'component_ui/image';
import ImageZoomControlsUI from 'component_ui/zoom-controls';
import ShowHidden from 'component_ui/show-hidden';
import DropdownRepositioner from 'component_ui/dropdown-repositioner';
import HtmlUpdater from 'component_ui/html-updater';

$(() => {
    const dropdowns = DetachedDropdown.createAll('[data-detached-dropdown]');

    LikeData.attachTo('[data-flight-like-button]', {
        likeUrl: $('[data-flight-like-button]').data('like-url'),
    });
    LikeButton.attachTo('[data-flight-like-button]');

    $('[data-login-signup-like-button]').on('click', () => {
        $(document).trigger('uiLikeButtonClicked');
    });

    AddComment.attachTo('[data-comment-new]');
    FullScreen.attachTo('[data-page-wrapper]');
    FullscreenModeUI.attachTo('[data-entry]');

    ImageUI.attachTo('[data-image-container]');
    ImageZoomControlsUI.attachTo('[data-image-zoom-controls]');

    ShowHidden.attachTo('[data-show-hidden]');

    ToggleVisible.attachTo('[data-toggle-visible]', {
        hideOnBodyClick: true,
    });

    $('.fullscreen__panel__body').on('uiScrollToTargetRequested', function(e) {
        $(this).animate(
            {
                scrollTop: $(e.target).offset().top,
            },
            0
        );
    });
    HtmlUpdater.attachTo('[data-login-signup-container]', {
        eventName: 'uiLikeButtonClicked',
        templateSelector: "[data-update-html-template='login-or-signup']",
    });

    DropdownRepositioner.attachTo('[data-login-signup-like-button]', {
        eventName: 'uiLikeButtonClicked',
        dropdowns,
    });

    $(document).trigger('uiNeedsContestsOpenForInvitation');
});



// WEBPACK FOOTER //
// ./src/js/page/profiles-designs.js